module.exports = __webpack_public_path__ + "img/vertical_3_1_0.c17a88a9.png";